import React from "react";
import Currency from "./Currency";
import { Col, Row } from "react-bootstrap";

export default function ErgebnisRow({
  label,
  einheit,
  preisProEinheit,
  einheiten,
  zwischensumme
}) {
  return (
    <Row>
      <Col sm={3}>{label}</Col>
      <Col sm={2} style={{ textAlign: "right" }}>
        {einheit}
      </Col>
      <Col sm={2} style={{ textAlign: "right" }}>
        <Currency value={preisProEinheit} />
      </Col>
      <Col sm={2} style={{ textAlign: "right" }}>
        {" "}
        {einheiten}{" "}
      </Col>
      <Col sm={2} style={{ textAlign: "right" }}>
        <Currency value={zwischensumme} />
      </Col>
    </Row>
  );
}



// WEBPACK FOOTER //
// ./src/components/inputs/ErgebnisRow.js